import { render, staticRenderFns } from "./CalculateGpa.vue?vue&type=template&id=477f038e&"
import script from "./CalculateGpa.vue?vue&type=script&lang=js&"
export * from "./CalculateGpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports